
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Invoice } from "@/components/Invoice";
import { Project } from "@/types/Project";
import { TimeEntry } from "@/components/TimeEntryForm";

interface InvoicePreviewCardProps {
  handleInvoiceSettings: () => void;
  filteredEntries: TimeEntry[];
  projects: Project[];
  selectedMonth: Date;
}

export function InvoicePreviewCard({ handleInvoiceSettings, filteredEntries, projects, selectedMonth }: InvoicePreviewCardProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Invoice Preview</CardTitle>
            <CardDescription>
              Preview how your invoice will look before exporting
            </CardDescription>
          </div>
          <Button 
            variant="outline" 
            size="sm"
            onClick={handleInvoiceSettings}
          >
            <Settings className="mr-2 h-4 w-4" />
            Invoice Settings
          </Button>
        </div>
      </CardHeader>
      <Separator />
      <CardContent className="pt-4">
        <Invoice 
          entries={filteredEntries} 
          projects={projects} 
          month={selectedMonth} 
        />
      </CardContent>
    </Card>
  );
}
